// extracted by mini-css-extract-plugin
export default {"inputWrapper":"aYr9EW","label":"bYr9EW","placeholder":"cYr9EW","emptyValue":"dYr9EW","clear":"eYr9EW","inputElement":"fYr9EW","external":"gYr9EW","searchIcon":"hYr9EW"};